var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21528 10.4335C5.06549 10.4323 4.92226 10.3719 4.81694 10.2653L0.169655 5.61805C0.115983 5.56605 0.0733067 5.5038 0.0441624 5.43499C0.0150182 5.36619 0 5.29222 0 5.21749C0 5.14277 0.0150182 5.0688 0.0441624 4.99999C0.0733067 4.93119 0.115983 4.86894 0.169655 4.81694L4.81694 0.169655C4.86894 0.115983 4.93119 0.0733067 4.99999 0.0441624C5.0688 0.0150182 5.14277 0 5.21749 0C5.29222 0 5.36619 0.0150182 5.43499 0.0441624C5.5038 0.0733067 5.56605 0.115983 5.61805 0.169655C5.72426 0.275896 5.78394 0.419976 5.78394 0.570207C5.78394 0.720438 5.72426 0.864518 5.61805 0.970759L1.37352 5.21528L5.61805 9.46423C5.69602 9.54428 5.74879 9.64546 5.7698 9.75522C5.79082 9.86498 5.77917 9.97849 5.73629 10.0817C5.69341 10.1849 5.62118 10.2732 5.52857 10.3358C5.43596 10.3983 5.32703 10.4323 5.21528 10.4335Z",
    fill: "#3C7AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.a5327da0767d738aec578d865f17451b.svg";
export { ForwardRef as ReactComponent };